const customStatusColors: {
  [key: `custom${number}`]: string;
} = {
  custom1: "#F24812",
  custom2: "#E6006D",
  custom3: "#B7148C",
  custom4: "#88148C",
  custom5: "#F79100",
};

export default (index: number) => {
  const colorNumFrom1To5 = (index % 5) + 1;
  return customStatusColors[`custom${colorNumFrom1To5}`];
};
